module.exports = __webpack_public_path__ + "img/WP2023-ExhibitionProspectus-thumb.5f7040aa.png";